<template>
  <section class="device-page">
    <div class="container">
      <header class="hero">
        <p class="eyebrow">for Perfect Ear Disease Management</p>
        <h1>Otiton Smart Therapeutic Device</h1>
        <p class="sub">Simultaneous Ear Imaging and Treatment — All in One Device</p>
      </header>

      <figure class="block"><img src="/img/therapeutic/device-1.jpg" alt="overview" loading="lazy" /></figure>
      <figure class="block"><img src="/img/therapeutic/device-2.jpg" alt="benefits" loading="lazy" /></figure>
      <figure class="block"><img src="/img/therapeutic/device-3.jpg" alt="650nm & colors" loading="lazy" /></figure>
      <figure class="block"><img src="/img/therapeutic/device-4.jpg" alt="materials & AI app" loading="lazy" /></figure>

      <div class="cta">
        <a href="/question" class="btn-primary">Contact us</a>
        <a href="/Innovation" class="btn-secondary">Back to Innovation</a>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: "SmartTherapeuticDevice" };
</script>

<style scoped>
.device-page{padding:72px 0}
.hero{text-align:center;margin-bottom:32px}
.hero .eyebrow{font-size:14px;opacity:.7;margin-bottom:8px}
.hero h1{font-size:clamp(28px,3.2vw,40px);font-weight:800;margin:0 0 8px}
.hero .sub{font-size:16px;opacity:.85}
.block{margin:24px 0}
.block img{width:100%;height:auto;border-radius:8px;display:block;box-shadow:0 6px 22px rgba(0,0,0,.08)}
.cta{margin-top:28px;display:flex;gap:12px;justify-content:center;flex-wrap:wrap}
.btn-primary,.btn-secondary{padding:10px 16px;border-radius:8px;text-decoration:none;font-weight:600}
.btn-primary{background:#0d2b3c;color:#fff}.btn-secondary{background:#f2f5f8;color:#0d2b3c}

</style>
